<template>
  <div
    class="pb-audio-player-square row no-gutters"
  >
    <div class="main col min-w-0 p-0" :style="{background:`url(${logo}) center center / cover no-repeat fixed`}">
      <div class="top-line"></div>
      <div class="top-content">
       <div class="row no-gutters top-title-logo">
        <div class="col min-w-0">
          <h3 class="channel-name">
            <a :target="setting.podcastLink?'_blank':'_self'" :href="setting.podcastLink || 'javascript:void();'">{{
              setting.podcastTitle
            }}</a>
          </h3>
        </div>
        <div v-if="setting.pbad" class="col-auto pb-brand-small-logo pr-2">
          <a
            class="logo"
            target="_blank"
            href="http://www.podbean.com?utm_campaign=pb_web_audio_square_player&utm_medium=logo&utm_source=pb_web_player"
            title="Podbean"
            >
            <icon-podbean-logo></icon-podbean-logo>
          </a>
        </div>
      </div>
       <div class="row no-gutters">
        <div class="col min-w-0">
          <h2 class="episode-name">
            <a :target="logoUrl?'_blank':'_self'" :href="logoUrl || 'javascript:void();'">{{
              episode.title
            }}</a>
          </h2>
        </div>
        <div class="col-auto pb-actions pr-2">
          <a
            class="info"
            v-if="info"
            href="javascript:;"
            @click="setNonAppDownloadDialogOpen(); isShowInfoDialog = true"
            title="Info"
          >
            <icon-info/>
          </a>
          <a
            class="downloadLink"
            v-if="podcastApps.length>0"
            href="javascript:;"
            @click="setNonAppDownloadDialogOpen(); isShowPodcastAppsDialog = true"
            title="Podcast Apps"
          >
            <icon-rss/>
          </a>
          <a
            class="downloadLink"
            target="_blank"
            v-if="download && episode.downloadLink"
            :href="episode.downloadLink"
            title="Download"
          >
            <icon-download></icon-download>
          </a>
          <a
            class="share"
            v-if="share && episode.shareLink"
            href="javascript:;"
            @click="setNonAppDownloadDialogOpen(); isShowShareDialog = true"
            title="Share"
          >
            <icon-share/>
          </a>
          <div class="chapters" v-if="chapters.length>0">
            <a href="javascript:;" @click="setNonAppDownloadDialogOpen(); isShowChaptersDialog=true" title="Chapter">
              <icon-list-chapers></icon-list-chapers>
            </a>
          </div>
        </div>
      </div>
      </div>
      <div class="bottom-content">
        <div class="pb-internal-player">
          <pb-player
            ref="pbPlayer"
            :options="videoOptions"
            :type="episode.type"
            :startAt="startAt"
            :episode="episode"
            @pause="pause"
            @play="play"
            @ready="ready"
            :crossorigin="episode.crossorigin"
          ></pb-player>
          <player-toolbar @seekBackward="seekBackward" @seekForward="seekForward"></player-toolbar>
          <player-loading></player-loading>
      </div>
      <canvas id="wave-canvas" ref="canvas"></canvas>
      </div>

      <app-download-square class="text-center" v-show="showAppDownloadStatus === 1"></app-download-square>
      <share-dialog v-if="share && episode.shareLink" @hide="isShowShareDialog=false"  v-show="isShowShareDialog"></share-dialog>
      <info-dialog v-if="info" @hide="isShowInfoDialog=false"  v-show="isShowInfoDialog"></info-dialog>
      <podcast-apps-dialog @hide="isShowPodcastAppsDialog=false"  v-show="isShowPodcastAppsDialog"></podcast-apps-dialog>
      <chapters-list-dialog @seek-to-chapter-time="chapterGoTo" @hide="isShowChaptersDialog=false" v-show="isShowChaptersDialog"></chapters-list-dialog>
    </div>
  </div>
</template>

<script>
    import {mapGetters, mapState} from "vuex";
    import PbPlayer from "@/components/PbPlayer";
    import ShareDialog from "@/components/ShareDialog";
    import InfoDialog from "@/components/InfoDialog";
    import AppDownloadSquare from "./AppDownloadSquare";
    import IconDownload from "@/components/IconDownload";
    import IconShare from "./icons/IconShare";
    import IconInfo from "./icons/IconInfo";
    import IconPodbeanLogo from "./icons/IconPodbeanLogo";
    import PlayerToolbar from "./PlayerToolbar";
    import PlayerLoading from "./PlayerLoading";
    import { showWave } from "@/common/utils";
    import IconRss from "./icons/IconRss";
    import PodcastAppsDialog from "./PodcastAppsDialog";
    import ChaptersListDialog from '@/components/ChaptersListDialog.vue';
    import IconListChapers from "../../live-player/src/components/icons/IconListChapers";
    import {MUTATION_UPDATE} from "@/store/mutations";

    export default {
  name: "AudioPlayerSquare",
  components: {
    IconListChapers,
    ChaptersListDialog,
    PodcastAppsDialog,
    IconRss,
      PlayerLoading,
      PlayerToolbar, IconPodbeanLogo, IconShare, IconInfo, IconDownload, ShareDialog, InfoDialog, AppDownloadSquare, PbPlayer },
  computed: {
    ...mapState([
      "setting",
      "startAt",
      "download",
      "share",
      "info",
      "logoLink",
      "showAppDownloadStatus",
      "podcastApps",
      "chapters"
    ]),
    ...mapGetters(["episode"]),
    logoUrl(){
      if(this.logoLink == "episode_page"){
        return this.episode.link;
      }else if(this.logoLink == "podcast_page"){
        return this.setting.podcastLink;
      }else{
        return "";
      }
    },
    videoOptions() {
      return {
        language: "en",
        autoplay: false,
        controls: true,
        controlBar: {
          fullscreenToggle: false,
          durationDisplay: false,
          mouseTimeDisplay: false,
          children: [
            "playToggle",
            "currentTimeDisplay",
            "progressControl",
            "remainingTimeDisplay",
            // "currentTimeDisplay",
            // "muteToggle",
            // "volumeControl",
            // "playbackRateMenuButton"
          ]
        },
        loadingSpinner: false,
        bigPlayButton: false,
        sources: [
          {
            src: this.episode.resource,
            type: this.episode.resourceMimetype
          }
        ]
      };
    }
  },
  data() {
    return {
      timer: null,
      isShowShareDialog: false,
      isShowInfoDialog: false,
      isShowPodcastAppsDialog: false,
      logo: "",
      isShowChaptersDialog: false,
    };
  },
  mounted() {
    let logo = this.episode.logo;
    this.logo = logo;
    let image = new Image();
    image.src = this.episode.largeLogo;
    image.onload = () => {
      if (this.logo === logo){
        this.logo = image.src;
      }
    };
  },
  methods: {
    chapterGoTo(seconds){
      this.isShowChaptersDialog = false;
      this.$refs.pbPlayer.setCurrentTime(seconds);
    },
    ready() {
      if (this.episode.enableWave){
        showWave();
      }
    },
    pause() {
      // this.stopDraw();
    },
    play() {
      // this.startDraw();
    },
    seekBackward(){
      this.$refs.pbPlayer.addCurrentTime(- 15);
    },
    seekForward(){
      this.$refs.pbPlayer.addCurrentTime(+ 15);
    },
    setNonAppDownloadDialogOpen() {
      this.$store.commit(MUTATION_UPDATE, ["isNonAppDownloadDialogOpen", true]);
    },
  }
};
</script>

<style lang="scss" >
.pb-audio-player-square {
  .vjs-text-track-cue{
    div{
      color: #ffffff !important;
    }
  }
  border: 1px solid #dedede;
  height: 100%;
  .main {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .top-line{
      position: absolute;
      width: 100%;
      height: 4px;
      z-index: 99;
      flex-shrink: 0;
    }
    .top-title-logo{
     height: 30px;
    }
    .top-content{
      position: absolute;
      top: 0;
      width: 100%;
      padding-top: 10px;
      padding-bottom: 15px;
      background: linear-gradient(rgb(25 29 35 / 0.9), rgb(43 50 60 / 0));
      .pb-actions{
        display: flex;
        padding-right: 8px !important;
        margin-top: 3px;
      }
    }
    h2.episode-name{
      font-size: 20px;
      padding-top: 2px;
      line-height: 1.2;
    }
    h3.channel-name{
      font-size: 16px;
      font-weight: normal;
      padding-top: 5px;
    }
    h3.channel-name,h2.episode-name{
      color: #ffffff;
      a{
        color: #ffffff;
      }
    }
    .pb-actions{
      .downloadLink{
        margin-right: 2px;
      }
      a{
        padding: 2px 5px;
        display: inline-block;
        border-radius: 4px;
        line-height: 1.2;
        color: #eeeeee;
        cursor: pointer;
        text-decoration: none;
        position: relative;
        top: -3px;
        .icon-download{
          width: 21px;
          height: 21px;
          position: relative;
          top: -2px;
        }
        .bi-share-fill{
          width: 15px;
          height: 15px;
        }
        span{
          font-size: 0.75rem;
          margin-left: 6px;
        }
      }
      .chapters{
        position: relative;
        margin-left: 3px;
        a{
          svg{
            width: 18px;
            height: 18px;
            color: #ffffff;
          }
        }
      }
    }
    .player-double-speed{
      top: 10%;
      margin-left: 30px;
      .double-speed{
        color: #ffffff !important;
      }
      button{
        &:hover,&:focus{
          opacity: 0.75;
        }
        svg{
          width: 20px;
          height: 20px;
          path{
            fill: #ffffff !important;
          }
        }
      }
    }

    .pb-brand-small-logo {
      padding-right: 10px !important;
      .logo{
        color: #dfdfdf;
        svg{
          width: 50px;
        }
      }
    }

    .video-js {
      width: 100%;
      height: 40px;
      background-color: transparent;

      .vjs-control-bar {
        display: flex;
       background-color: transparent;
      }
    }
  }

  /* 整个播放条 */
  .pb-internal-player{
    position: relative;
  }
  .video-js{
     .vjs-control-bar{
       padding-left: 10px;
       height: 50px;
      .vjs-button{
        width: 50px;
        height: 50px;
        border-radius: 50px;
        line-height: 50px;
        position: relative;
        .vjs-icon-placeholder{
          color: #ffffff;
          font-size: 20px;
          display: block;
          position: absolute;
          top: -5px;
          bottom: 0;
          left: 0;
          right: 0;
          &:before{
            //line-height: unset;
          }
        }
        &:hover{
          opacity: 0.9;
        }
      }
      /* 播放开始默认时间样式 */
      .vjs-time-control{
        display: block !important;
        position: absolute;
        top: 2px;
        font-family: inherit;
        height: 16px;
        span{
          color: #ffffff !important;
        }
      }
      .vjs-current-time{
        left: 58px;
      }
      .vjs-remaining-time{
        right: 0;
      }
      /* 播放进度条样式 */
      .vjs-progress-control{
        margin-top: 7px;
        .vjs-progress-holder{
          font-size:1em;
          margin-left: 8px;
          border-radius: 3px;
          height: 0.5em;
          .vjs-play-progress{
            font-size: 1.5em;
          }
          .vjs-slider-bar{
            border-bottom-left-radius: 3px;
            border-top-left-radius: 3px;
            font-size: 1.5em;
            padding-left: 4px;
            &:before{
              top: -4px;
            }
          }
        }
      }
    }
  }
  .bottom-content{
    position: absolute;
    bottom: 0;
    width: 100%;
    background: linear-gradient(rgb(0 0 0 / 0%),rgb(0 0 0 / 70%), rgb(0 0 0 / 90%));
    padding-top: 50px;
    .player-loading{
      top: -10px;
      .item{
        width: 7px;
        height: 7px;
      }
    }
  }
  canvas {
    height: 40px;
    width: 100%;
    position: relative;
    bottom: -7px;
  }
}
</style>
